import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Container,
  FormFeedback,
  Form,
  Button,
} from "reactstrap";
import { Formik } from "formik";
import Breadcrumbs from "../../../components/Common/Breadcrumb";
import { useNavigate, useParams } from "react-router-dom";
import ResultHandler from "../../../components/ResultHandler";
import FormButtonHandler from "../../../components/FormButtonHandler";
import { useResponse } from "../../../hooks/useResponse";
import { useTranslation } from "react-i18next";
import useCustomValidation from "../validationSchema";
import { getDeliverable, editDeliverable } from "../../../api/deliverable";

const EditDeliverable = () => {
  const { t } = useTranslation();
  const { deliverableSchema } = useCustomValidation();
  const navigate = useNavigate();
  const { id } = useParams();
  const dealIddealId = localStorage.getItem("dealIddealId");
  console.log("dealIddealId", dealIddealId);
  const [initialValues, setInitialValues] = useState({
    timeline: "",
    notes: "",
    deliverable: "",
  });

  const { setData, loading, error, success } = useResponse(editDeliverable, () => {
    navigate(`/deals/show/${dealIddealId}`);
  });

  useEffect(() => {
    const fetchDeliverable = async () => {
      try {
        const res = await getDeliverable(id);
        const data = res?.data;

        setInitialValues({
          timeline: data?.timeline || "",
          notes: data?.notes || "",
          deliverable: data?.deliverable || "",
        });
      } catch (err) {
        console.error("Failed to fetch deliverable", err);
      }
    };

    fetchDeliverable();
  }, [id]);

  return (
    <div className="page-content">
      <Container fluid={true}>
        <Breadcrumbs title={`${t("btns.Edit")} ${t("Deliverable")}`} />

        <Formik
          enableReinitialize
          initialValues={initialValues}
          validationSchema={deliverableSchema}
          onSubmit={(values) => {
            setData({ id, data: values, type: "edit" });
          }}
        >
          {(formik) => (
            <Form
              className="needs-validation"
              onSubmit={(e) => {
                e.preventDefault();
                formik.handleSubmit();
              }}
            >
              <FormGroup className="mb-3">
                <Label>{t("Timeline")}</Label>
                <Input
                  name="timeline"
                  placeholder={t("Enter timeline")}
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.timeline}
                  invalid={!!(formik.touched.timeline && formik.errors.timeline)}
                />
                <FormFeedback>{formik.errors.timeline}</FormFeedback>
              </FormGroup>

              <FormGroup className="mb-3">
                <Label>{t("Deliverable")}</Label>
                <Input
                  name="deliverable"
                  placeholder={t("Enter deliverable")}
                  type="text"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.deliverable}
                  invalid={!!(formik.touched.deliverable && formik.errors.deliverable)}
                />
                <FormFeedback>{formik.errors.deliverable}</FormFeedback>
              </FormGroup>

              <FormGroup className="mb-3">
                <Label>{t("Notes")}</Label>
                <Input
                  name="notes"
                  placeholder={t("Enter notes")}
                  type="textarea"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.notes}
                  invalid={!!(formik.touched.notes && formik.errors.notes)}
                  rows="4"
                />
                <FormFeedback>{formik.errors.notes}</FormFeedback>
              </FormGroup>

              <FormButtonHandler btnTxt={t("Update")} loading={loading} />

              <ResultHandler
                error={error}
                success={success}
                successMsg={t("Updated Successfully!")}
              />
            </Form>
          )}
        </Formik>
      </Container>
    </div>
  );
};

export default EditDeliverable;
